import { api } from '@/services/api';

function filenameFromDisposition(disposition: string | null): string | null {
  if (!disposition) return null;

  const utf8Match = disposition.match(/filename\*=UTF-8''([^;]+)/i);
  if (utf8Match?.[1]) {
    return decodeURIComponent(utf8Match[1].trim());
  }

  const asciiMatch = disposition.match(/filename="?([^";]+)"?/i);
  return asciiMatch?.[1]?.trim() || null;
}

export async function downloadWorkspaceFile(path: string, fallbackFilename?: string): Promise<void> {
  const response = await api.files.download(path, false);
  const blob = await response.blob();
  const filename = filenameFromDisposition(response.headers.get('Content-Disposition'))
    || fallbackFilename
    || path.split('/').pop()
    || 'download';

  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}
